import { initMap, equalCols, getCookie } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const tourBookings = {
        isLoading: false,
        init() {
            $(document).on('click', '#tour-bookings-send-btn', this, this.send);
        },
		send(event) {
			const _this = event.data;
			event.preventDefault();

			if (_this.isLoading) {
                return false;
            }

			let errors = false;
			$('.tour-bookings-form').find('.form-control').removeClass('is-invalid');
			$('#form-notifications').html('');

			if ($('#company').val() == '') {
				$('#company').addClass('is-invalid');
				errors = true;
			}
			if ($('#name').val() == '') {
				$('#name').addClass('is-invalid');
				errors = true;
			}
			if ($('#email').val() == '') {
				$('#email').addClass('is-invalid');
				errors = true;
			}
			if ($('#phone').val() == '') {
				$('#phone').addClass('is-invalid');
				errors = true;
			}
			if ($('#date').val() == '') {
				$('#date').addClass('is-invalid');
				errors = true;
			}
			if (!$('#terms_and_condition').is(":checked")) {
				$('#terms_and_condition').addClass('is-invalid');
				errors = true;
			}

			if (errors) {
				$('#form-notifications').html('<div class="alert alert-danger" role="alert">'+tourBookingsErrorText+'</div>');
				return false;
			}

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values = '&company=' + $('#company').val();
			values += '&name=' + $('#name').val();
			values += '&email=' + $('#email').val();
			values += '&phone=' + $('#phone').val();
			values += '&date=' + $('#date').val();
			values += '&message=' + $('#message').val();
			values += '&terms_and_condition=' + ($('#terms_and_condition:checked').val()?1:0);
			//values += '&newsletter=' + ($('#newsletter:checked').val()?1:0);
			values += '&_token=' + $('#_token').val();
			$.ajax({
	            type: "POST",
	            url: tourBookingsPost,
	            data: values,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#' + errorKey).addClass('is-invalid');
                                errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }
						$('#form-notifications').html('<div class="alert alert-danger" role="alert">'+errorHtml+'</div>');
                        return false;
                    }

					if (response.status == 1) {
						$('.tour-bookings-form').find('.form-control').val('');
						//$('#newsletter').prop('checked', false);
						$('#terms_and_condition').prop('checked', false);

						Swal.fire({
							icon: 'success',
							title: 'Success!',
							html: response.message
						});

						if (cookies_advertisement == 1) {
							//gtag('event', 'conversion', {'send_to': 'AW-732195211/z_5UCI7a8-cBEIvTkd0C'});
						}

						if (cookies_advertisement == 1 || cookies_social == 1) {
							//fbq('track', 'Lead');
						}

						window.lintrk('track', { conversion_id: 9865345 });

						return false;
					}

					$('#form-notifications').html('<div class="alert alert-danger" role="alert">'+response.message+'</div>');
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		}
    };

    if ($('.tour-bookings-form').length) {
        tourBookings.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/tour-bookings.js